import {
  audienceAssociationSectionStyle,
  commonDoubleListBoxStyle,
  convertToLocalStyle,
  glyphIconStyle,
  helpbuttonStyle,
  paginationStyle,
  searchboxStyle,
  uiblockerStyle,
  audienceModalStyles,
  audienceExpressionStyle,
  audienceCombinedListStyle,
  tableStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { criterionSettingCompanyStyles } from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';

export const getCompanyTargetStyles = (_, { palette }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),
    ...audienceModalStyles({ palette }, { modalWidth: 500 }),
    ...audienceExpressionStyle(),
    ...audienceCombinedListStyle({ palette }),
  },
  pickerContainer: {
    ...criterionSettingCompanyStyles({ palette }, { targetGridWidth: 816 }),
    ...audienceAssociationSectionStyle({ palette }, { singleListBoxWidth: 450 }),
    ...commonDoubleListBoxStyle({ palette }),
    ...paginationStyle({ palette }),
    ...tableStyle({ palette }),
    ...searchboxStyle({ palette }),
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    '& .statusEnabled_icon::before': {
      color: '#107c10',
      content: '"\\ECCC"',
      fontFamily: 'MsAds MDL2 Assets',
    },
    '& .statusPaused_icon::before': { // Todo: find icons for status disabled etc.
      color: '#323130',
      content: '"\\F6B0"',
      fontFamily: 'MsAds MDL2 Assets',
    },
    '& .statusExcluded_icon::before': { // Todo: find icons for status disabled etc.
      color: '#A80000',
      content: '"\\E733"',
      fontFamily: 'MsAds MDL2 Assets',
    },
  },
});
